import * as React from 'react'

/**
 * Renders the ProductHeader component.
 * @param {Props} props - The props object containing captain, className, and title
 * @return {JSX.Element} - The JSX representation of the ProductHeader component
 */
const ProductHeader = ({ captain, className, title }) => {
  return (
    <div className={`product-hdr ${className}`}>
      <div className="product-hdr__captain">{captain}</div>
      <div className="product-hdr__wrap">
        <h1 className="product-hdr__title">{title}</h1>
      </div>
    </div>
  )
}

/**
 * @typedef {object} Props
 * @property {string} captain - The captain of the product header
 * @property {string} className - The class name to be added to the product header
 * @property {string} title - The title of the product header
 */

export default ProductHeader
